/**
 * Shared date helpers for report windows.
 *
 * All windowing is done in the business timezone (Australia/Sydney) so "today"
 * and "yesterday" mean the operational day in Sydney regardless of where the
 * viewer's browser is.
 */
export const BUSINESS_TZ = 'Australia/Sydney';

/** Today's calendar date (YYYY-MM-DD) in the business timezone. */
export function businessTodayISO(tz: string = BUSINESS_TZ): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: tz,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(new Date());
  const get = (t: string) => parts.find((p) => p.type === t)?.value ?? '01';
  return `${get('year')}-${get('month')}-${get('day')}`;
}

/** Calendar yesterday (YYYY-MM-DD) — the real day before today in the business timezone. */
export function businessYesterdayISO(tz: string = BUSINESS_TZ): string {
  const today = businessTodayISO(tz);
  const d = new Date(`${today}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() - 1);
  return d.toISOString().slice(0, 10);
}
